module.exports = __webpack_public_path__ + "components/star-rating/static/yellow/0.75-21ff04cf052064f70719f14269fa8836.svg";